
export interface ICenterAdminDataUpdateRequest{
    testParam: string;
}